var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalOnboardingDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#C0C2C6",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_42384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.667 14.9998H23.3337V13.3332C23.3337 12.4165 22.5837 11.6665 21.667 11.6665H18.3337C17.417 11.6665 16.667 12.4165 16.667 13.3332V14.9998H13.3337C12.417 14.9998 11.667 15.7498 11.667 16.6665V26.6665C11.667 27.5832 12.417 28.3332 13.3337 28.3332H26.667C27.5837 28.3332 28.3337 27.5832 28.3337 26.6665V16.6665C28.3337 15.7498 27.5837 14.9998 26.667 14.9998ZM18.3337 13.3332H21.667V14.9998H18.3337V13.3332ZM26.667 26.6665H13.3337V16.6665H26.667V26.6665Z",
    fill: "#C0C2C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8337 18.3332H19.167V20.8332H16.667V22.4999H19.167V24.9999H20.8337V22.4999H23.3337V20.8332H20.8337V18.3332Z",
    fill: "#C0C2C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_42384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalOnboardingDisabled);
export default __webpack_public_path__ + "static/media/hospital-onboarding-disabled.99ca4fc06c912c09a06dca7744d854b7.svg";
export { ForwardRef as ReactComponent };